module.exports = __webpack_public_path__ + "img/3D_Face_Left.ad390363.gif";